var Notifications = $.extend(false, BaseModule ,{

    api_route : 'notifications',

    data : {
        module      : 'notifications',
        page        : 1,
        limit       : 20,
        order_by    : 'id:desc',
        view        : 'list'
    },
    after_load_entry:function(){
        
        $('input[name="data[action]"]').on('change',action_change);
        $('select[name="data[url]"]').on('change',action_change);
        $('input[name="type"]').on('change',action_change);

        function action_change(){

            if($('input[name="data[action]"]:checked').val() == 'navigation' || $('input[name="data[action]"]:checked').val() == 'auto-redirect'){
                $('select[name="data[url]"]').closest('.form-group').show();
            }else{
                $('select[name="data[url]"]').closest('.form-group').hide();
            }

            if($('select[name="data[url]"]').val().indexOf('expo-partner-hall') != -1 || $('select[name="data[url]"]').val().indexOf('panorama') != -1){              
                $('select[name="data[nodeid]"]').closest('.form-group').show();
            }else if($('select[name="data[url]"]').data('selected_value').indexOf('expo-partner-hall') != -1 || $('select[name="data[url]"]').data('selected_value').indexOf('panorama') != -1){              
                $('select[name="data[nodeid]"]').closest('.form-group').show();
            } else{
                $('select[name="data[nodeid]"]').val('');
                $('select[name="data[nodeid]"]').closest('.form-group').hide();
            }

        }

        action_change();

        this.save();
    },

	init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict"; 
    Notifications.init();
});